import { createRouter, createWebHistory } from "vue-router";
import { studentGuards, salesTeamGuards, loginGuards } from "./guards";

const routes = [
  {
    path: "/auth-:auth_user_token",
    name: "AuthPage",
    component: () => import("../views/Authentication/AuthPage.vue"),
  },
  {
    path: "/thank-you",
    name: "ThankYouPage",
    beforeEnter: studentGuards,
    component: () => import("../views/Authentication/ThankYouPage.vue"),
  },
  // notifications
  {
    path: "/notifications",
    name: "NotificationPage",
    component: () => import("../views/Notifications/NotificationsList.vue"),
  },
  // page not found
  {
    path: "/:pagenotfound(.*)*",
    name: "PageNotFound",
    component: () => import("../views/PageNotFound.vue"),
  },
  // Template manager
  {
    path: "/email-campaign/create-email-template/:id?",
    name: "EmailTemplate",
    component: () => import("../views/EmailCampaign/EmailTemplateView.vue"),
  },
  
  {
    path: "/all-campaigns",
    name: "CampaignView",
    component: () => import("../views/EmailCampaign/CampaignView.vue"),
  },
  {
    path: "/email-campaign/create-template/:id?",
    name: "CreateTemplate",
    component: () => import("../views/EmailCampaign/CreateTemplate.vue"),
  },
  // sms
  {
    path: "/sms-campaign/create-sms-template/:id?",
    name: "SmsTemplate",
    component: () => import("../views/TemplateManager/SmsTemplate.vue"),
  },
  // Whatsapp template
  {
    path: "/whatsapp-campaign/create-whatsapp-template/:id?",
    name: "WhatsappTemplate",
    component: () => import("../views/TemplateManager/WhatsappTemplate.vue"),
  },
  // end of template manager
  // student routes
  {
    path: "/student-dashboard",
    name: "StudentDashboard",
    component: () => import("../views/StudentViews/StudentDashboard.vue"),
  },
  {
    path: "/document-view/:id?/:applicationNo?/:userId?/",
    name: "DocumentView",
    component: () => import("../views/StudentViews/DocumentView.vue"),
  },

  // student routes ends

  // leads routes
  {
    path: "/lead-report-download-history",
    name: "LeadReportDownloadHistory",
    component: () => import("../views/Leads/LeadReportDownloadHistory.vue"),
  },
  {
    path: "/lead-reports",
    name: "LeadReport",
    beforeEnter: salesTeamGuards,
    component: () => import("../views/Leads/LeadReport.vue"),
  },
  {
    path: "/dashboard",
    name: "LeadDashboard",
    beforeEnter: salesTeamGuards,
    component: () => import("../views/Leads/DashboardView.vue"),
  },
  {
    path: "/bulk-upload",
    name: "BulkUpload",
    component: () => import("../views/Leads/BulkUpload.vue"),
  },
  {
    path: "/lead-details/:id?",
    name: "leadDetails",
    beforeEnter: salesTeamGuards,
    component: () => import("../views/Leads/LeadDetails.vue"),
  },
  {
    path: "/applications/",
    name: "LeadApplications",
    beforeEnter: salesTeamGuards,
    component: () => import("../views/Leads/ApplicationsView.vue"),
  },
  {
    path: "/lead-list",
    name: "leadList",
    beforeEnter: salesTeamGuards,
    component: () => import("../views/Leads/LeadList.vue"),
  },
  {
    path: "/excel-upload-details",
    name: "ExcelUploadLogs",
    beforeEnter: salesTeamGuards,
    component: () => import("../views/Leads/ExcelUploadData.vue"),
  },
  {
    path: "/applications/level-1-verified",
    name: "Level1Verified",
    beforeEnter: salesTeamGuards,
    component: () => import("../views/Leads/Level1Verified.vue"),
  },
  {
    path: "/applications/level-2-verified",
    name: "Level2Verified",
    beforeEnter: salesTeamGuards,
    component: () => import("../views/Leads/Level2Verified.vue"),
  },
  {
    path: "/bulk-upload-logs",
    name: "BulkUploadList",
    component: () => import("../views/Leads/BulkUploadList.vue"),
  },
  {
    path: "/pre-defined-list",
    name: "PreDefinedField",
    component: () => import("../views/Leads/PreDefinedField.vue"),
  },
  // document verification
  {
    path: "/document-verification/:userId/:applicationId/:applicationNo",
    name: "DocumentVerification",
    props: true,
    beforeEnter: salesTeamGuards,
    component: () => import("../views/Leads/DocumentVerification.vue"),
  },
  {
    path: "/lead-download-history",
    name: "LeadDownloadHistory",
    component: () => import("../views/Leads/LeadDownloadHistory.vue"),
  },
  {
    path: "/application-download-history",
    name: "ApplicationDownloadHistory",
    component: () => import("../views/Leads/ApplicationDownloadHistory.vue"),
  },

  // lead routes end

  // Application management routes
  {
    path: "/application-form/:name/:status/:id/",
    name: "PaymentApplicationForm",
    component: () => import("../views/ApplicationViews/ApplicationForm.vue"),
    beforeEnter: studentGuards,
  },
  {
    path: "/application-preview/:id/:application_id/:student_id",
    name: "PreviewApplication",
    component: () => import("../views/ApplicationViews/PreviewApplication.vue"),
    beforeEnter: studentGuards,
  },
  {
    path: "/all-application-list",
    name: "AllApplicationsList",
    component: () =>
      import("../views/ApplicationViews/AllApplicationForms.vue"),
    beforeEnter: studentGuards,
  },
  {
    path: "/application-form/:name/:id",
    name: "ApplicationForm",
    component: () => import("../views/ApplicationViews/ApplicationForm.vue"),
    beforeEnter: studentGuards,
  },
  {
    path: "/student/queries/",
    name: "StudentQueries",
    component: () => import("../views/StudentViews/QueriesView.vue"),
    beforeEnter: studentGuards,
  },
  {
    path: "/student/payments/",
    name: "StudentPayments",
    component: () => import("../views/StudentViews/PaymentsView.vue"),
    beforeEnter: studentGuards,
  },
  {
    path: "/student/communications/",
    name: "StudentCommunications",
    beforeEnter: studentGuards,
    component: () => import("../views/StudentViews/CommunicationView.vue"),
  },
  // Application management route end

  // Authentication routes
  {
    path: "/",
    name: "Login",
    beforeEnter: loginGuards,
    component: () => import("../views/Authentication/LoginView.vue"),
  },
  {
    path: "/signup",
    name: "SignUp",
    component: () => import("../views/Authentication/SignUpView.vue"),
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: () => import("../views/Authentication/ForgotPassword.vue"),
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: () => import("../views/Authentication/ResetPassword.vue"),
  },
  {
    path: "/accounts/reset-password/:uuid?",
    name: "ChangePassword",
    component: () => import("../views/Authentication/ChangePassword.vue"),
  },

  // user management
  {
    path: "/user-list",
    name: "UserView",
    component: () => import("../views/UserView/UserView.vue"),
  },

  // profile page
  {
    path: "/profile",
    name: "ProfilePage",
    component: () => import("../views/ProfilePage.vue"),
  },

  // marketing
  {
    path: "/marketing/raw-data-list",
    name: "RawDataList",
    component: () => import("@/views/Marketing/RawDataList.vue"),
  },
  {
    path: "/marketing/raw-data-detail/:id",
    name: "RawDataDetail",
    component: () => import("@/views/Marketing/RawDataDetail.vue"),
  },
  {
    path: "/lead-allocation",
    name: "LeadMapping",
    component: () => import("../views/Marketing/LeadMapping.vue"),
  },
  {
    path: "/allocated-leads/:id?",
    name: "MappedLeads",
    component: () => import("../views/Marketing/MappedLeads.vue"),
  },
  // reports and analytics
  {
    path: "/reports-and-analytics/whatsapp-logs/incoming-whatsapp-messages",
    name: "ICWhatsAppMessages",
    component: () => import("../views/Reports/ICWhatsAppMessages.vue"),
  },
    {
    path: "/reports-and-analytics/whatsapp-logs",
    name: "WhatsAppLogs",
    component: () => import("../views/Reports/WhatsAppLogs.vue"),
  },
  {
    path: "/reports-and-analytics/communication",
    name: "CommunicationLogs",
    component: () => import("../views/Reports/CommunicationLogs.vue"),
  },
  {
    path: "/reports-and-analytics/communication-detail/:id?/:email_type",
    name: "CommunicationDetail",
    component: () => import("../views/Reports/CommunicationDetail.vue"),
  },
  {
    path: "/reports-and-analytics/call-logs",
    name: "CallLogsView",
    component: () => import("../views/Reports/CallLogsView.vue"),
  },
  {
    path: "/email-download-history",
    name: "EmailDownloadHistory",
    component: () => import("../views/Reports/EmailDownloadHistory.vue"),
  },
  {
    path: "/reports-and-analytics/bounced-logs",
    name: "BounceLogs",
    component: () => import("../views/Reports/BounceLogs.vue"),
  },
  {
    path: "/reports-and-analytics/whatsapp-detail/:id?",
    name: "WhatsappLogDetail",
    component: () => import("../views/Reports/WhatsappLogDetail.vue"),
  },
  // payment manager
  {
    path: "/payment-status/:order_id/",
    name: "PaymentStatus",
    component: () => import("@/views/PaymentManager/PaymentStatusPage.vue"),
  },
  {
    path: "/payu-payment-status/:order_id/",
    name: "PayUPaymentStatus",
    component: () => import("@/views/PaymentManager/PayUPaymentStatusPage.vue"),
  },
  {
    path: "/payment-page",
    name: "PaymentView",
    component: () => import("@/views/PaymentManager/PaymentView.vue"),
  },
  {
    path: "/payment-list",
    name: "PaymentList",
    component: () => import("@/views/PaymentManager/PaymentList.vue"),
  },
  {
    path: "/discount-coupon",
    name: "DiscountCoupon",
    component: () => import("@/views/PaymentManager/DiscountCoupon.vue"),
  },
  {
    path: "/discount-coupon-list",
    name: "CouponListView",
    component: () => import("@/views/PaymentManager/CouponListView.vue"),
  },
  {
    path: "/discount-coupon-detail-list/:id?/:name?",
    name: "CouponDetail",
    component: () => import("@/views/PaymentManager/CouponDetail.vue"),
  },
  {
    path: "/payment-download-history",
    name: "PaymentDownloadHistory",
    component: () =>
      import("@/views/PaymentManager/PaymentDownloadHistory.vue"),
  },
  // settings
  {
    path: "/entity-configuration/",
    name: "SettingsView",
    component: () => import("@/views/Settings/SettingsView.vue"),
  },
  {
    path: "/entity-configuration/program",
    name: "ProgramView",
    component: () => import("@/views/Settings/ProgramView.vue"),
  },
  {
    path: "/entity-configuration/offline-tags",
    name: "OfflineTagsView",
    component: () => import("@/views/Settings/OfflineTagsView.vue"),
  },
  {
    path: "/entity-configuration/lead-stages",
    name: "LeadCreation",
    component: () => import("../views/Settings/LeadCreation.vue"),
  },
  {
    path: "/leadscore",
    name: "LeadScore",
    component: () => import("../views/Settings/LeadScore.vue"),
  },
  // partner pages
  {
    path: "/cp-sp-onboard/:id",
    name: "PartnerView",
    component: () => import("../views/Partners/PartnerView.vue"),
  },
  {
    path: "/cp-sp-onboard/re-submit/:id",
    name: "CpUpdateView",
    component: () => import("../views/Partners/CpUpdateView.vue"),
  },
  // student loan pages
  {
    path: "/loan-application",
    name: "LoanApplication",
    props: true,
    component: () => import("../components/Student/LoanApplicationForm.vue"),
  },

  {
    path: "/fees-receipt/:id",
    name: "FeesReceipt",
    component: () => import("../views/FeesReceipt.vue"),
  },
  {
    path: "/cp-onboard-list",
    name: "CpOnboardList",
    component: () => import("../views/CPOnboard/CPOnboardList.vue"),
  },
  // counsellor
  {
    path: "/counsellor",
    name: "CounsellorDashboard",
    component: () => import("../views/Counsellor/CounsellorDashboard.vue"),
  },
  // lead support
  {
    path: "/lead-support",
    name: "LeadSupport",
    component: () => import("../views/LeadSupport/LeadSupport.vue"),
  },
  {
    path: "/meta-login",
    name: "MetaLogin",
    component: () => import("../views/MetaLogin/MetaLogin.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
